module.exports = __webpack_public_path__ + "img/shopify-black.9f38c97b.png";